import React from "react";

import footerData from "../../../../footerData.json";
import Link from "next/link";
import CentreSection from "./centreSection";
import CopyrightSection from "./copyrightSection";

const FooterMenu = () => {
    const { quicLinks } = footerData || {};

    return (
        <>
            <div className="bg-gray-50 pt-8">
                <div className="md:py-10 px-4 sm:px-2 max-w-6xl mx-auto">
                    <div className="grid gap-2 grid-cols-1 md:grid-cols-12">
                        {/* Left Section */}
                        <div className="col-span-12 md:col-span-5 mb-8 md:mb-0">
                            <div className="w-full">
                                <div className="w-full">
                                    <h4 className="text-black font-bold text-base md:text-lg my-4">
                                        Quick Links
                                    </h4>
                                    {/* On mobile: use grid layout to reduce vertical height */}
                                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-2 cursor-pointer">
                                        {quicLinks?.map((item) => (
                                            <Link
                                                key={item?.id}
                                                href={item?.url}
                                            >
                                                <p className="text-black text-sm hover:underline">
                                                    {item?.name}
                                                </p>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Right Section */}
                        <div className="col-span-12 md:col-span-7">
                            <h4 className="text-black font-bold text-base md:text-lg my-4">
                                Centres
                            </h4>
                            <CentreSection />
                        </div>
                    </div>
                    <CopyrightSection />
                </div>
            </div>
        </>
    );
};

export default FooterMenu;
